// extracted by mini-css-extract-plugin
export default {"linkButton":"link_linkButton__fsfQP"};